import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getMe, logout as apiLogout, registerUser, loginUser } from '../lib/api';
import AuthModal from '../components/AuthModal';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const me = await getMe();
      setUser(me);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  // Opens the email/password + Google modal
  const login = () => setAuthOpen(true);
  const closeAuth = () => setAuthOpen(false);

  const loginGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const registerWithPassword = async ({ name, email, password }) => {
    const u = await registerUser({ name, email, password });
    setUser(u);
    setAuthOpen(false);
    return u;
  };

  const loginWithPassword = async ({ email, password }) => {
    const u = await loginUser({ email, password });
    setUser(u);
    setAuthOpen(false);
    return u;
  };

  const logout = async () => {
    try { await apiLogout(); } catch (e) { /* ignore */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, closeAuth, loginGoogle, registerWithPassword, loginWithPassword, logout, checkAuth }}>
      {children}
      <AuthModal open={authOpen} onClose={closeAuth} onGoogle={loginGoogle} onRegister={registerWithPassword} onLogin={loginWithPassword} />
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
